export default __webpack_public_path__ + "static/media/herkesecay.a11cc5ca.mp3";